module.exports = __webpack_public_path__ + "img/AE5007-01.52bd4f21.jpg";